//这里是 微信公众号 模块的路由文件

const basePath = "/admin/wechat/";
export default [
    //自定义菜单
    {
        path: `${basePath}menu`,
        name: 'WechatMenu',
        component: r => require.ensure([], () => r(require('@/views/wechat/WechatMenu')), 'Wechat')
    },
    //欢迎语配置
    {
        path: `${basePath}welcoming`,
        name: 'WechatWelcoming',
        component: r => require.ensure([], () => r(require('@/views/wechat/WechatWelcoming')), 'Wechat')
    },
    //自动回复
    {
        path: `${basePath}response`,
        name: 'WechatResponse',
        component: r => require.ensure([], () => r(require('@/views/wechat/WechatResponse')), 'Wechat')
    }
]
